import React, { useMemo } from 'react';
import { Text, CustomSVG, Empty } from '../../../components';
import CPU from '../../../assets/icons/cpu.svg?raw';
import RAM from '../../../assets/icons/ram.svg?raw';
import STORAGE from '../../../assets/icons/storage.svg?raw';
import { getCriteriaIcon } from '../../../pages/Discovery/Inventory/components/DiscoveryInventoryTable/components/StorageAndMemoryCriteria/CriteriaIcons';
import { getGiBfromMiB } from '../../../lib/helpers';
import { getStorageCriteria, formatDecimal } from '../../../pages/Discovery/helpers';
import { NewRMCard } from '../NewRMCard';
import { useScrollMask } from '../../ScrollMask/useScrollMask';
import { formatStorageSize } from '../../SummaryWrapper/inventorySummaryHelpers';
import classNames from 'classnames';
import './TopTenOpportunitiesCard.scss';

const formatStorage = (gib) => {
    const { value, unit } = formatStorageSize(gib);
    return { value: formatDecimal(value), unit };
};

const metrics = [
    { key: 'cpu', svg: CPU, criteriaKey: 'cpuCriteria', unit: 'vCPU' },
    { key: 'ram', svg: RAM, criteriaKey: 'ramCriteria', unit: 'GiB' },
    { key: 'storage', svg: STORAGE, criteriaKey: 'storageCriteria', unit: 'GiB' },
];

export const TopTenOpportunitiesCard = ({ title, topTenSavings = [], className = '', ...props }) => {
    const details = useMemo(
        () =>
            topTenSavings.map((item) => {
                const { cpu, cpu_count, ram, ram_size, storage, storage_size } = item.cost_savings;
                return {
                    text: item.name,
                    cpu: cpu > 0 && cpu_count ? cpu_count : null,
                    cpuCriteria: item.cpu_utilization,
                    ram: ram > 0 && ram_size ? formatStorage(getGiBfromMiB(ram_size)) : null,
                    ramCriteria: item.ram_utilization,
                    storage: storage > 0 && storage_size ? formatStorage(getGiBfromMiB(storage_size)) : null,
                    storageCriteria: getStorageCriteria(item.storage_disks, item.storage_disks_used, item.storage_utilization),
                };
            }),
        [topTenSavings]
    );
    const titleContent = (
        <div className="header-left">
            <Text size="large" color="muted">
                {title}
            </Text>
            {/* <Text color="primaryBlue" bold>
                See All
                <RightOutlined />
            </Text> */}
        </div>
    );
    const contentRow = (details) => {
        if (details.length === 0) {
            return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No data available" />;
        }
        return details.map((item, index) => {
            const { text } = item;
            return (
                <div key={index} className="content-row">
                    <Text size="small" extraBold color="muted">
                        {text}
                    </Text>
                    <div className="metrics">
                        {metrics.map(({ key, svg, criteriaKey, unit }) => {
                            const raw = item[key];
                            if (raw == null) return null;
                            const displayValue = typeof raw === 'object' ? raw.value : raw;
                            const displayUnit = typeof raw === 'object' ? raw.unit : unit;
                            return (
                                <div key={key}>
                                    <CustomSVG svg={svg} className="metric-icon" />
                                    {getCriteriaIcon(item[criteriaKey])}
                                    <Text size="small" color="secondary">
                                        <Text color="primaryBlue" xxlBold className="metric-value">
                                            {displayValue}
                                        </Text>{' '}
                                        {displayUnit}
                                    </Text>
                                </div>
                            );
                        })}
                    </div>
                </div>
            );
        });
    };

    const [scrollRef, maskClass] = useScrollMask();
    // const handleOpportunityToggle = (value) => {
    //     console.log('Toggled to:', value);
    // };
    
    return (
        <NewRMCard className={classNames(className, 'top-ten-opportunities-card')} showMoreIcon={false} {...props}>
            <header>
                {titleContent}
                {/* <Segmented options={['VM', 'App']} onChange={handleOpportunityToggle} size="small" shape="round" /> */}
            </header>
            <div ref={scrollRef} className={classNames('top-ten-content-container', maskClass, 'scrollbar-visible')}>
                {contentRow(details)}
                            </div>
        </NewRMCard>
    );
};